import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef,} from '@angular/core';
import {Router} from '@angular/router';
import {TaskServiceService} from '../../services/task-service.service';
import {BoardGroupModel, BoardTableModel} from '../../models/tasktable.model';
import {ModalService} from '../../services/modal/modal.service';
import {MemberService} from '../../services/member.service';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {CrmService} from '../../services/api/crm.service';
import {AlertService} from '../../services/notify/alert.service';
import {ModalSettingsModel} from '../../models/modal.model';
import {MemberModel} from '../../models/user.model';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-task-dashboards',
    templateUrl: './task-dashboards.component.html',
    styleUrls: ['./task-dashboards.component.scss']
})
export class TaskDashboardsComponent implements OnInit, OnChanges {
    @Output() public emitReloading: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() public emitTaskSelect: EventEmitter<BoardTableModel> = new EventEmitter<BoardTableModel>();
    @Input() public boards: BoardTableModel[] = [];
    @Input() public isView = false;
    @Input() boardGroups: BoardGroupModel[] = [];
    @Input() headerVisible = true;
    @Input() expandedBoardID:number|null = 66;

    boardWrap: any = [];
    selectedBoard: BoardTableModel;
    allAccordionHeaders: {
        headerText: string,
        id: number,
        dataForTemplate: { boards: BoardTableModel[], groupId: number },
        editHeaderText: boolean,
    }[] = [];
    addBoardModal: NgbModalRef;
    editGroupId: number;

    currentMember: MemberModel;
    showAddBoardTemplate = false;

    constructor(
        protected modalService: ModalService,
        protected router: Router,
        protected taskService: TaskServiceService,
        protected memberService: MemberService,
        protected crmService: CrmService,
        protected alert: AlertService,
        public translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        this.memberService.getCurrentMember().then(res => {
            this.currentMember = res;
            this.checkGroups();
        });

        this.taskService.eminOnCreateBoardGroup.subscribe(res => {
            const newGroup = {
                headerText: res.title,
                id: res.id,
                dataForTemplate: {boards: res.boards, groupId: res.id},
                editHeaderText: this.currentMember.project_setting.is_project_admin,
            };
            this.allAccordionHeaders.push(newGroup);
        });
    }


    ngOnChanges(changes: SimpleChanges): void {
        if (changes.boardGroups && !changes.boardGroups.firstChange) {
            changes.boardGroups.currentValue.forEach((group: BoardGroupModel) => {
                if (this.allAccordionHeaders.find(accordionData => accordionData.id === group.id)) {
                    this.allAccordionHeaders.find(accordionData => accordionData.id === group.id).dataForTemplate.boards = group.boards;
                }
            });
        }
        // if (this.addBoardModal) {
        //     this.addBoardModal.close();
        // }
    }

    checkGroups(): void {
        const prevGroups = [];
        this.boardGroups.forEach(group => {
            const data = {
                headerText: group.title,
                id: group.id,
                dataForTemplate: {boards: group.boards, groupId: group.id},
                editHeaderText: this.currentMember.project_setting.is_project_admin,
                opened:group.id === this.expandedBoardID
            };
            prevGroups.push(data);
        });
        this.allAccordionHeaders = prevGroups;
    }

    selectDash(board: BoardTableModel, needNavigate = true): void {
        if (this.isView) {
            this.emitTaskSelect.emit(board);
        } else {
            if (needNavigate) {
                this.taskService.setBoard(board.alias, true).then(() => {
                    void this.router.navigate(['account', 'tasks', 'all', board.alias]);
                });
            } else {
                this.editBoardGroup(board);
            }
        }
    }

    selectBoard(event: MouseEvent, board: BoardTableModel, content: TemplateRef<any>): void {
        event.stopPropagation();
        event.preventDefault();
        this.selectedBoard = board;
        this.modalService.openTemplateModal(content);
    }

    openBoardSettings(event: MouseEvent, board: BoardTableModel): void {
        event.stopPropagation();
        event.preventDefault();
        void this.router.navigate(['account', 'tasks', 'options', 'statuses'], {queryParams: {alias: board.alias}});
    }

    wrapBoard(event: MouseEvent, i: number): void {
        event.stopPropagation();
        event.preventDefault();
        this.boardWrap[i] = !this.boardWrap[i];
    }

    openAddBoardModal(addBoardView: TemplateRef<any>, id: number): void {
        this.editGroupId = id;
        this.showAddBoardTemplate = false;

        this.addBoardModal = this.modalService.openTemplateModal(addBoardView, 'xl');
        const sub = this.addBoardModal.shown.subscribe(() => {
            this.showAddBoardTemplate = true;
            sub.unsubscribe();
        });
    }

    editBoardGroup(board: BoardTableModel): void {
        const data = {
            name: board.name,
            alias: board.alias,
            icon: board.icon,
            description: board.description,
            group_id: this.editGroupId,
        };
        this.crmService.updateBoard(board.alias, data).subscribe({
            next: res => {
                const boardGroupId = this.editGroupId ? this.editGroupId : board.group_id;
                const group = this.allAccordionHeaders.filter(x => x.id === boardGroupId)[0];

                if (!this.addBoardModal) {
                    group.dataForTemplate.boards = group.dataForTemplate.boards.filter(x => x.id !== res.board.id);
                }
                this.emitReloading.emit(true);
                this.alert.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
            }
        });
    }

    editGroupName(emitData: { newName: string, id: any }): void {
        this.crmService.updateGroupTitle(emitData.id, emitData.newName).subscribe({
            next: () => {
                this.emitReloading.emit(true);
                this.alert.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
            }, error: err => {
                this.alert.setAlert(err.message, 'blue');
                this.allAccordionHeaders.find(header => header.id === emitData.id).headerText
                    = this.boardGroups.find(x => x.id === emitData.id).title;
            }
        });
    }

    editGroupToNull(event: MouseEvent, board: BoardTableModel): void {
        event.stopPropagation();
        event.preventDefault();
        this.editGroupId = null;
        this.editBoardGroup(board);
    }

    deleteBoardGroup(id: number): void {
        const currentGroup = this.allAccordionHeaders.filter(x => x.id === id)[0];
        const modalSettings: ModalSettingsModel = {
            modalHeader: this.translate.instant('CONFIRM.HEADERS.DELETE'),
            modalBody: this.translate.instant('CONFIRM.TEXT.DELETE_GROUP', {headerText: currentGroup.headerText}),
            buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.YES'),
            buttonClose: this.translate.instant('CONFIRM.BUTTONS.NO'),
        };

        const modal = this.modalService.createFromSettings(modalSettings);
        modal.result.then(data => {
            if (data) {
                this.crmService.deleteGroupById(id).subscribe({
                    next: res => {
                        this.alert.setAlert(res.message, 'green');
                        this.emitReloading.emit(true);
                        this.allAccordionHeaders = this.allAccordionHeaders.filter(x => x.id !== id);
                    }, error: err => {
                        this.alert.setAlert(err.message, 'blue');
                    }
                });
            }
        }).catch(() => {
            return;
        });
    }
}
